import { DEFAULT_PAGE_SIZE, DEFAULT_SORTING_CRITERIA } from './constants'
import { NonFilterParams, SearchFilters } from './types'

export const defaultFilters: SearchFilters = {
  make: [],
  model: [],
  mileage: [],
  fromPrice: [],
  toPrice: [],
  fromYear: [],
  toYear: [],
  store: [],
  site: [],
  vehicleYear: [],
  colour: [],
  trim: [],
  driveType: [],
  gearbox: [],
  doors: [],
  fuelType: [],
  bodyType: [],
  seats: [],
  condition: [],
  fromEngineSize: [],
  toEngineSize: [],
  rangeInMiles: [],
  tags: [],
  features: [],
  financeType: [],
}

export const defaultNonFilterParams: NonFilterParams = {
  sortingCriteria: DEFAULT_SORTING_CRITERIA,
  pageNumber: 1,
  pageSize: DEFAULT_PAGE_SIZE,
}
